import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate } from '../api/dataverseClient';

export interface Decision {
  dagrun_pm_decisionid: string;
  dagrun_pm_name: string;
  // The decision statement itself — distinct from rationale (why) and
  // impact (effects). Name stays a short human title.
  dagrun_pm_decisiontext: string | null;
  dagrun_pm_rationale: string | null;
  dagrun_pm_impact: string | null;
  dagrun_pm_decisiondate: string | null;
  dagrun_pm_madeby: string | null;
  dagrun_pm_madebyname: string | null;
  createdon?: string;
  _dagrun_pm_projectid_value: string;
}

const FIELDS = [
  'dagrun_pm_decisionid', 'dagrun_pm_name', 'dagrun_pm_decisiontext', 'dagrun_pm_rationale', 'dagrun_pm_impact',
  'dagrun_pm_decisiondate', 'dagrun_pm_madeby', 'dagrun_pm_madebyname',
  'createdon', '_dagrun_pm_projectid_value',
];

export async function getProjectDecisions(pca: IPublicClientApplication, projectId: string): Promise<Decision[]> {
  return dvList<Decision>(pca, 'dagrun_pm_decisions', {
    select: FIELDS,
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
    orderby: 'dagrun_pm_decisiondate desc,createdon desc',
  });
}

export async function createDecision(
  pca: IPublicClientApplication,
  projectId: string,
  fields: { name: string; decisiontext?: string | null; rationale: string; impact?: string | null; decisiondate?: string | null; madeby: string; madebyname: string },
): Promise<string> {
  const body: Record<string, unknown> = {
    dagrun_pm_name: fields.name,
    dagrun_pm_rationale: fields.rationale,
    dagrun_pm_madeby: fields.madeby,
    dagrun_pm_madebyname: fields.madebyname,
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${projectId})`,
  };
  if (fields.decisiontext) body.dagrun_pm_decisiontext = fields.decisiontext;
  if (fields.impact) body.dagrun_pm_impact = fields.impact;
  if (fields.decisiondate) body.dagrun_pm_decisiondate = fields.decisiondate;
  return dvCreate(pca, 'dagrun_pm_decisions', body);
}

// Decisions are immutable — no updateDecision, no deleteDecision exported by design.
